var map = {
	"./bali/kuta.png": 3705,
	"./bali/nusa_dua.png": 638,
	"./bali/sanur.png": 7927,
	"./bali/tanah_lot.png": 1052,
	"./bali/uluwatu.png": 330,
	"./jogja/baron.png": 5800,
	"./jogja/keraton_jogja.png": 2135,
	"./jogja/malioboro.png": 7263,
	"./jogja/parangtritis.png": 4414,
	"./jogja/prambanan.png": 6119,
	"./jogja/wediombo.png": 4922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7048;